<script setup lang="ts"></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M9.25171 7.1067C8.06551 6.86848 6.83387 7.02802 5.74752 7.56063C4.66118 8.09323 3.78076 8.96916 3.24261 10.0528C2.70447 11.1364 2.53863 12.3672 2.77079 13.5546C3.00295 14.742 3.62015 15.8197 4.52679 16.6208C5.43344 17.422 6.57894 17.9018 7.78588 17.986C8.99283 18.0702 10.1939 17.7542 11.203 17.0867C12.2121 16.4193 12.973 15.4377 13.3678 14.2941C13.7626 13.1504 13.7694 11.9085 13.3869 10.7606"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.4127 17.8923C15.6001 18.1317 16.8334 17.9725 17.9211 17.4392C19.0087 16.906 19.8899 16.0286 20.4279 14.9432C20.9658 13.8579 21.1304 12.6253 20.8961 11.4368C20.6618 10.2483 20.0417 9.17045 19.1321 8.37048C18.2225 7.57051 17.0742 7.09321 15.8655 7.01266C14.6568 6.93212 13.4554 7.25284 12.4477 7.92504C11.4399 8.59723 10.6823 9.58331 10.2924 10.7302C9.90245 11.8771 9.90204 13.1206 10.2912 14.2677"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
